import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Switch } from '../ui/switch';
import { BellRing } from 'lucide-react';
import { notificationsApi } from '../../services/api';
import { toast } from 'sonner';

const ROWS = [
  { key: 'readiness_alerts', label: 'Readiness changes', help: 'Alert me the moment an asset changes readiness (e.g. becomes Not ready).' },
  { key: 'critical_defect_alerts', label: 'Critical defects', help: 'Alert me immediately when a critical defect is raised.' },
  { key: 'daily_digest', label: 'Daily 5am digest', help: 'Email me a morning summary of fleet readiness in my local time.' },
];

const NotificationPreferencesCard = () => {
  const [prefs, setPrefs] = useState({ readiness_alerts: true, critical_defect_alerts: true, daily_digest: true });
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    notificationsApi.getMyPreferences()
      .then(({ data }) => setPrefs(data))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const toggle = async (key, val) => {
    const next = { ...prefs, [key]: val };
    setPrefs(next);
    try { await notificationsApi.putMyPreferences(next); }
    catch { setPrefs(prefs); toast.error('Could not save preference'); }
  };

  return (
    <Card data-testid="notification-prefs-card">
      <CardHeader>
        <CardTitle className="uppercase tracking-wide flex items-center gap-2">
          <BellRing className="w-5 h-5" />
          My alerts
        </CardTitle>
        <CardDescription>Choose which alerts you personally receive. These are per-user — they don't change anyone else's.</CardDescription>
      </CardHeader>
      <CardContent className="divide-y divide-border">
        {ROWS.map((r) => (
          <div key={r.key} className="flex items-center justify-between gap-4 py-3 first:pt-0 last:pb-0">
            <div className="min-w-0">
              <div className="text-sm font-medium">{r.label}</div>
              <p className="text-xs text-muted-foreground">{r.help}</p>
            </div>
            <Switch checked={!!prefs[r.key]} disabled={!loaded} onCheckedChange={(v) => toggle(r.key, v)} data-testid={`pref-${r.key}`} />
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default NotificationPreferencesCard;
